<body>
    <div class="dash">
        <!-- Patient sidebar start here -->
      <!-- <app-patsidebar></app-patsidebar> -->
        <!-- Patient sidebar end here -->
        <div class="dash-app">
            <!-- Patient Header start here -->
            <!-- <app-patheader></app-patheader> -->
        
            <!-- Patient Header end here -->

            <!-- Patient Main Body start here -->
<h1>Hospital page is working</h1>


            <!-- Patient Main Body end here-->
        </div>
    </div>
</body>